export default __webpack_public_path__ + "static/media/hero.709ae0e4.png";